import { useMemo } from 'react';
import {
  DataTable,
  PageHeader,
  type DataTableColumn,
} from '@vipso/shared';
import { useGetAuditLogsQuery } from '../api/adminApi';

type AuditRow = Record<string, unknown>;

function formatValue(value: unknown) {
  if (value == null) return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

export function AuditPage() {
  const { data, isLoading } = useGetAuditLogsQuery({ limit: 100 });

  const rows = data?.auditLogs ?? [];

  const columns: DataTableColumn<AuditRow>[] = useMemo(
    () => [
      {
        key: 'id',
        header: 'ID',
        render: (row) => formatValue(row.id),
      },
      {
        key: 'action',
        header: 'Action',
        render: (row) => formatValue(row.action ?? row.event),
      },
      {
        key: 'entity',
        header: 'Entity',
        render: (row) => formatValue(row.entityType ?? row.module),
      },
      {
        key: 'entityId',
        header: 'Entity ID',
        render: (row) => formatValue(row.entityId),
      },
      {
        key: 'actor',
        header: 'Actor',
        render: (row) => formatValue(row.actorId ?? row.userId),
      },
      {
        key: 'createdAt',
        header: 'When',
        render: (row) => formatValue(row.createdAt),
      },
    ],
    [],
  );

  return (
    <>
      <PageHeader
        title="Audit log"
        description="Recent platform activity across tenants and organizations."
      />

      <DataTable
        columns={columns}
        rows={rows.map((row, index) => ({ ...row, __rowKey: String(row.id ?? row.createdAt ?? index) }))}
        loading={isLoading}
        getRowId={(row) => row.__rowKey as string}
        emptyTitle="No audit entries"
        emptyDescription="Audit events will appear here as admins take action."
      />
    </>
  );
}
